import { render, staticRenderFns } from "./ReferenceUnitForm.vue?vue&type=template&id=2fbcf67a"
import script from "./ReferenceUnitForm.vue?vue&type=script&lang=js"
export * from "./ReferenceUnitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports